export default __webpack_public_path__ + "static/media/Pot1.77731f90.svg";